import React from 'react';
import s from './s.module.less';
import { Button, message, Checkbox } from 'antd';
import GlobalLayerStore from 'store/GlobalLayer';
import { Channel } from 'types/common';
import { getChannelPayLink } from 'api/subscription';
import { setPendingSubscriptionChannel } from 'utils/localstore';
import { isDevEnv } from 'utils/common';
import dayjs from 'utils/dayjs';

type IProps = {
    onConfirm?: () => void;
};

const PlatformAgreementUrl = isDevEnv()
    ? 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/agreement/platform-access-and-services-20250428.html'
    : 'https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/agreement/platform-access-and-services-20250428.html';

const ChannelSubscription = (props: IProps) => {
    const [loading, setLoading] = React.useState(false);
    const [getGlobalLayer] = GlobalLayerStore.useStore();
    const channel: Channel | undefined = getGlobalLayer('pendingSubscriptionChannel');
    const [checked, setChecked] = React.useState(false);
    const { onConfirm } = props;

    let period = 'month';
    if (channel?.billingCycle === 'Quarterly') {
        period = 'quarter';
    }
    if (channel?.billingCycle === 'Yearly') {
        period = 'year';
    }
    const freeTrial = !!(channel?.freeTrialDays && channel?.freeTrialDays > 0);
    return (
        <div className={s.wrap}>
            <div className={s.logo}>
                <img
                    src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                />
            </div>
            <div className={s.list}>Subscribe to Premium Channel</div>
            <div className={s.priceWrap}>
                <div className={s.price}>$ {channel?.kiwiPrice?.toFixed(2)}</div>
                <div className={s.priceLabel}>
                    <div>per</div>
                    <div>{period}</div>
                </div>
            </div>
            <div className={s.channelItem}>
                <div className={s.left}>
                    <img
                        src={channel?.logo}
                    />
                </div>
                <div className={s.right}>
                    <div className={s.nameAndPrice}>
                        <div className={s.name}>
                            {channel?.name}
                        </div>
                        <div className={s.price}>
                            ${channel?.kiwiPrice?.toFixed(2)}
                        </div>
                    </div>
                    <div className={s.time}>
                        Billed {channel?.billingCycle?.toLowerCase()}
                    </div>
                    <div className={s.total}>
                        <div className={s.label}>Total due today</div>
                        <div className={s.value}>{freeTrial ? 0 : channel?.kiwiPrice?.toFixed(2)}</div>
                    </div>
                </div>
            </div>

            <div className={s.premiumChannel}>
                <div className={s.title}>Platform agreement confirmation</div>
                <div className={s.desc}>
                    To ensure transparency and a smooth experience, please review and agree to our Platform Agreement before moving forward.
                </div>
                <iframe className={s.iframe} title="overview" src={PlatformAgreementUrl} />
                <Checkbox checked={checked} onChange={() => setChecked(!checked)} className="mb-6">By checking this box, I agree to the terms outlined in the agreement on {dayjs(new Date().getTime()).format('YYYY-MM-DD')}.</Checkbox>
            </div>

            <div className={s.btnWrap}>
                <Button
                    onClick={async () => {
                        if (!channel?.subscriptionPriceId) {
                            message.error('Plan not set');
                            return;
                        }
                        setLoading(true);
                        const result = await getChannelPayLink(channel.id);
                        if (!result.error) {
                            const link = result.data.data;
                            if (link) {
                                setPendingSubscriptionChannel(channel);
                                onConfirm?.();
                                window.open(link, '_self');
                            } else {
                                message.error('Pay link not found');
                            }
                        }

                        setLoading(false);
                    }}
                    block
                    size="large"
                    type="primary"
                    className={s.btn}
                    loading={loading}
                    disabled={!checked}
                >
                    Confirm
                </Button>
                <div className={s.tips}>
                    By confirming, you authorize the payment using your saved info via Stripe, ensuring a secure transaction.
                </div>
                <div className={s.power}>
                    Powered by <b>Stripe</b>
                </div>
            </div>
        </div>
    );
};

export default ChannelSubscription;
